import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faLink} from '@netx/core-icons';
import {canCreateShareLinkMetadataFromCurrentCart} from '../enablers';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {CART_CURRENT_EVENT} from './constants';

export const cartActionExportAttributesShareLinkIcon = faLink;

/**
 * Export attributes from cart and create share link
 * @param params
 * @returns Action
 */
export const cartActionExportAttributesShareLink = (
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'cart-export-attributes-share-link',
	cb: () => dispatcher.trigger(CART_CURRENT_EVENT.EXPORT_ATTRIBUTES_SHARE_LINK),
	enableTest: () => canCreateShareLinkMetadataFromCurrentCart(),
	icon: cartActionExportAttributesShareLinkIcon,
	get label() {
		return CART_CURRENT_ACTION_LABELS.EXPORT_ATTRIBUTES_SHARE_LINK;
	},
	...params,
});

export default cartActionExportAttributesShareLink;
